<script>
	const utilities = require('utilities');
	const classUtilities = require('utilities/classUtilities');
	const archiveClass = classUtilities.archiveClass;
	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		data: function () {
			return {
				clazz: null,
				callback: function () {},
				isArchiving: false
			};
		},
		methods: {
			onArchiveClick: function (clazz) {
				this.isArchiving = true;
				let callback = this.callback;
				archiveClass(clazz).then(() => {
					this.isArchiving = false;
					this.close();
					callback();
				});
			},
			close: function () {
				utilities.closeModals();
			}
		},
		computed: {
			name: function () {
				if (this.clazz && this.clazz.name) {
					return this.clazz.name;
				}
				return '';
			},
			classCode: function () {
				if (this.clazz && this.clazz.classCode) {
					return this.clazz.classCode;
				}
				return '';
			},
			loaderImageSrc() {
				return assetUrl('/assets/dist/images/loader.gif');
			}
		},
		mounted() {
			let self = this;
			self.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-archive-class') {
					return true; // let some other handler take this
				}

				if (opts.clazz) {
					this.clazz = opts.clazz;
				}
				if (opts.callback) {
					this.callback = opts.callback;
				}
				return false;
			});

			self.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-archive-class') {
					return true; // let some other handler take this
				}

				this.clazz = null;
				this.callback = function () {};
				return false;
			});
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-archive-class"
		:ok="false"
		:centered="true">
		<template slot="header-container">
			<h2>Archive Class Confirmation</h2>
		</template>
		<div
			slot="content"
			class="archive-class-modal-body">
			<h3>You are archiving the class &ldquo;{{ name }}&rdquo; (Code {{ classCode }}).</h3>
			<p
				v-if="isArchiving"
				aria-live="polite">
				<img
					:src="loaderImageSrc"
					role="presentation"
					alt="Loading" />
				Please wait while your class is archived.
			</p>
			<template v-else>
				<p>
					You can unarchive a class.
					<outbound-link
						data-outbound-link="ARCHIVE_MODAL"
						target="_blank"
						href="https://help.readworks.org/article/99-unarchiving-classes-how-do-i-do-it">
						Learn how.
					</outbound-link>
					When classes are archived, students and teachers can no longer see class information and assignments.
				</p>
				<p>
					<button
						class="button -outline"
						@click="close">
						Cancel
					</button>
					<button
						class="button"
						@click="onArchiveClick(clazz)">
						Archive
					</button>
				</p>
			</template>
		</div>
	</modal>
</template>
